import { Link } from "react-router-dom";
import { BRAND } from "@/lib/brand";

// Uses the approved ZRo Pe icon PNG asset (no SVG recreation).
export function LogoMark({ size = 34, className = "" }) {
  return <img src={BRAND.assets.icon} alt={BRAND.name} width={size} height={size} className={`object-contain ${className}`} />;
}

// Final approved primary ZRo Pe brand lockup (penguin + wordmark + tagline). Use where full space is available.
// Subtle light outline keeps the dark-blue elements legible on dark navy; invisible on light backgrounds.
export function LogoFull({ className = "" }) {
  return <img src={BRAND.assets.logoFull} alt={`${BRAND.name} — ${BRAND.tagline}`} className={`object-contain ${className}`} style={{ filter: "drop-shadow(0 0 1.5px rgba(255,255,255,0.9)) drop-shadow(0 0 1.5px rgba(255,255,255,0.6))" }} />;
}

export function Wordmark({ light = false, className = "" }) {
  return (
    <span className={`font-display text-lg font-extrabold tracking-tight ${light ? "text-white" : "text-[#0B132B]"} ${className}`}>
      ZRo<span style={{ color: BRAND.colors.teal }}> Pe</span>
    </span>
  );
}

export function Logo({ light = false, className = "", to = "/", showTagline = false, size = 34 }) {
  return (
    <Link to={to} className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <LogoMark size={size} className="shrink-0 rounded-[10px] shadow-sm" />
      <span className="flex flex-col leading-none">
        <Wordmark light={light} />
        {showTagline && <span className={`mt-0.5 text-[10px] font-medium ${light ? "text-slate-300" : "text-slate-500"}`}>{BRAND.tagline}</span>}
      </span>
    </Link>
  );
}
